import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card } from "@/components/ui/card";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Login failed");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center px-4 bg-slate-50">
      <Card className="w-full max-w-md p-8 rounded-2xl shadow-sm">
        <Link to="/" className="inline-block mb-6"><div className="font-display font-bold text-primary text-xl">Job Done Reviews</div></Link>
        <h1 className="font-display text-2xl font-bold mb-1">Welcome back</h1>
        <p className="text-slate-500 mb-6 text-sm">Log in to your account.</p>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-sm font-medium text-slate-700 mb-1.5 block">Email</label>
            <Input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="h-12 rounded-lg" placeholder="you@business.com" />
          </div>
          <div>
            <label className="text-sm font-medium text-slate-700 mb-1.5 block">Password</label>
            <Input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="h-12 rounded-lg" />
          </div>
          <Button data-testid="login-submit" disabled={busy} type="submit" className="w-full h-12 rounded-full bg-primary hover:bg-primary/90">
            {busy ? "Logging in…" : "Log in"}
          </Button>
        </form>
        <div className="mt-5 flex items-center justify-between text-sm">
          <Link to="/forgot" className="text-primary hover:underline" data-testid="login-forgot-link">Forgot password?</Link>
          <Link to="/signup" className="text-slate-600 hover:text-slate-900" data-testid="login-to-signup">Create account</Link>
        </div>
      </Card>
    </div>
  );
}
